<template>
    <div class="card notification ddialog">
        <b-field label="Name"
                 :type="{'is-danger': errors.has('name')}"
                 :message="errors.first('name')">
            <b-input v-model="venue.name" name="name" v-validate="'required'"></b-input>
        </b-field>
        <b-field label="Address"
                 :type="{'is-danger': errors.has('address')}"
                 :message="errors.first('address')">
            <b-input v-model="venue.address" type="string" name="address" v-validate="'required'"></b-input>
        </b-field>
        <b-field label="City"
                 :type="{'is-danger': errors.has('city')}"
                 :message="errors.first('city')">
            <b-input v-model="venue.city" type="string" name="city" v-validate="'required'"></b-input>
        </b-field>
        <b-field label="Website"
                 :type="{'is-danger': errors.has('website')}"
                 :message="errors.first('website')">
            <b-input v-model="venue.website" name="website" type="url" v-validate="'required|url:require_protocol'"></b-input>
        </b-field>
        <button class="button is-primary" @click="validateBeforeSubmit">Save</button>
    </div>
</template>

<script>

    const axios = require('axios');

    export default {
        name: "CreateVenue",
        data() {
            return {
            }
        },
        props: ["venue"],
        methods: {
            createVenue: function () {
                axios
                    .post(this.$backend + '/api/venues', this.venue)
                    .then(response => {
                            if (response.status == 200) {
                                this.$toast.open({
                                    message: 'Venue saved',
                                    type: 'is-success'
                                })
                            } else {
                                this.$toast.open({
                                    message: 'Error while saving venue',
                                    type: 'is-error'
                                })
                            }
                            this.$parent.close()
                        }
                    )
            },
            validateBeforeSubmit() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.createVenue()
                        return;
                    }
                    this.$toast.open({
                        message: 'Form is not valid! Please check the fields.',
                        type: 'is-danger',
                        position: 'is-bottom'
                    })

                });
            }
        }
    }
</script>

<style scoped>


    .ddialog{
        min-width: 400px;
    }

</style>
